import React, { useCallback} from 'react';
import { useAudioPlayerContext } from 'contexts/audio-context';
import play from '../../assets/images/play_icon.png';
import pause from '../../assets/images/pause_icon.png';
import back from '../../assets/images/r.svg';
import forward from '../../assets/images/v.svg';

type Props = {
  isPlaying: boolean
  togglePlay: () => void
  waveSurferInstance: React.MutableRefObject<any>
}

export const Controls: React.FC<Props> = ({ isPlaying, togglePlay, waveSurferInstance }) => {

  const {
    duration,
    audioRef,
    setDuration,
    progressBarRef,
    timeProgress,
    setTimeProgress,
  } = useAudioPlayerContext();

  const updateProgress = useCallback(() => {
    if (audioRef.current && progressBarRef.current && duration) {
      const currentTime = audioRef.current.currentTime;
      setTimeProgress(currentTime);

      progressBarRef.current.value = currentTime.toString();
      progressBarRef.current.style.setProperty(
        '--range-progress',
        `${(currentTime / duration) * 100}%`
      );
    }
  }, [duration, setTimeProgress, audioRef, progressBarRef]);

  const skipForward = () => {
    if (audioRef.current && waveSurferInstance.current) {
      const newTime = Math.min(audioRef.current.currentTime + 15, duration);
      audioRef.current.currentTime = newTime;
      waveSurferInstance.current.seekTo(newTime / duration); 
      updateProgress(); 
    }
  };


  const skipBackward = () => {
    if (audioRef.current && waveSurferInstance.current) {
      const newTime = Math.max(audioRef.current.currentTime - 15, 0);
      audioRef.current.currentTime = newTime;
      waveSurferInstance.current.seekTo(newTime / duration); 
      updateProgress(); 
    }
  };

  const formatTime = (time: number | undefined): string => {
    if (typeof time === 'number' && !isNaN(time)) {
      const minutes = Math.floor(time / 60);
      const seconds = Math.floor(time % 60);

      const formatMinutes = minutes.toString().padStart(2, '0');
      const formatSeconds = seconds.toString().padStart(2, '0');

      return `${formatMinutes}:${formatSeconds}`;
    }
    return '00:00';
  };

  return (
    <div className='lection-audio-controls'>
      <div className='lection-audio-controls-time'>
        <span>{formatTime(timeProgress)}</span>
        <span>{formatTime(duration)}</span>
      </div>
      <div className='lection-audio-controls-buttons'>
      <button 
        onClick={skipBackward}
        className='lection-audio-controlsB'
      >
        <img src={back} />
      </button>
      <button 
        onClick={togglePlay}
        className='lection-audio-controls-button'
      >
        <img src={isPlaying ? pause : play} />
      </button>
      <button 
        onClick={skipForward}
        className='lection-audio-controlsB'
      >
        <img src={forward} />
      </button>
      </div>
    </div>
  );
};
